module.exports = __webpack_public_path__ + "img/RCUNI.b90989e5.svg";